var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"my-3"},[_vm._v(" Orders List ")]),_c('order-list-table')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }